// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1HQgP","content":"GlobalSearch_content__3BZQU"};